














































































































































































































































































































































































































































/*
  getParam 获取教师信息管理页面参数
  getTeacherInfo 获取教师信息管理分页列表
  deleteTeacherInfo 删除教师信息
  markValid 标记是否有效
  setRecommend 推荐或取消推荐
  validTeacherNum 教师总人数/有效人数
*/
import { Vue, Component } from "vue-property-decorator";
import { Form as ElForm } from "element-ui";
//引入接口调用函数
import {
  getTeacherMaintain,
  addBlackList,
  removeBlackList,
  markValid,
  sendMessageTeacherMaintain,
  sendNoticeTeacherMaintain,
  getTeacherMaintainParam,
  validTeacherNum,
  resetPasswords,
  getMsgTeacher,
  activateAccount
} from "../../../api/teacherMaintain";
//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";
//引入vuex中的user模块
import { UserModule } from "../../../store/modules/user";
import { ruleNormal, rulePattern } from "../../../utils/common";

@Component({
  name: "teacherMaintain",
  components: {
    detail: () => import("./modules/detail.vue"),
    edit: () => import("./modules/edit.vue"),
    sendMessage: () => import("./modules/sendMessage.vue"),
    UploadProgress: () => import("@/components/UploadProgress/index.vue")
  },
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private validTeacherData: object = {}; //教师总数及有效教师数量
  private projectId: string = ""; //项目id（mixin 需要，maintain 无项目概念，保留空值）
  private sourceId: string = ""; //来源
  private subjectId: string = ""; //科目
  private districtId: string = ""; //市县
  private importDialogVisible: boolean = false; //导入弹窗
  private maintainUploadData = { progressId: -1 }; //上传入参
  private schoolName: string = ""; //单位名称
  private isValid: number | null = null; //是否有效
  private isBlacklist: number | null = null; //是否是黑名单
  private isActivate: number | null = null; //是否激活
  private teacherName: string = ""; //教师姓名
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private chooseRowArray: object[] = []; //勾选的数据row 集合
  private showDetail: boolean = false; //是否显示详情
  private currentTeacherId: string = ""; //要查看的teacherId
  private dialogFormVisible: boolean = false; //是否显示添加\编辑弹窗
  private showSendMessage: boolean = false; //是否显示发送短息/发送通知弹窗
  private editType: string = ""; //记录是 "添加" 还是 "修改"
  private editFormData: object = {}; //添加\编辑弹窗的数据
  private isProvinceRole: boolean = false; //是否是“省级管理员”
  private msgType: string = ""; //发送短信息or发送通知
  private fullscreenLoading: boolean = false; //spin toggle
  private showAdvancedSearch: boolean = false; //是否显示高级筛选
  //   blackListEditForm
  private blackListFormVisible: boolean = false; // 加入黑名单对话框
  private blackListEditForm: object = {}; //添加\编辑弹窗的数据

  // 是否有效表单
  private validationFormVisible: boolean = false; // 确认无效对话框
  private validationEditForm: object = {}; //添加\编辑弹窗的数据

  //页面参数
  private projects: object[] = []; //项目数组
  private sources: object[] = []; //“来源”数组
  private schools: object[] = []; //学校数组
  private genders: object[] = []; //性别数组
  private subjects: object[] = []; //科目数组
  private professionals: object[] = []; //职称数组
  private grades: object[] = []; //任课年级数组
  private treeVos: object = {}; //收件人
  private districts: object[] = []; //市区列表
  private tableHeight: number = 0;
  private showReset: boolean = false; // 显示重置密码窗口
  private old2NewPwd:object = { // 重置密码输入内容
    newPwd: '',
    checkPwd: ''
  }
  public $refs!: {
    table: HTMLFormElement;
  };

  created() {
    //获取教师总人数/有效人数
    this.getValidTeacherNum();
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();

  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  // 取消重置密码
  private noReset(){
    this.showReset = false;
    this.clearInputData()
  }

   // 清空输入框数据
  private clearInputData(){
    (this.old2NewPwd as any).newPwd = '';
    (this.old2NewPwd as any).oldPwd = '';
    (this.old2NewPwd as any).checkPwd = '';
  }

  // 校验两次密码一致
  private validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== (this.old2NewPwd as any).newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

   // 修改密码页面格式校验
  private ruleForm: object = {
    newPwd: [
      ruleNormal("请输入新的用户密码"),
      rulePattern(
        /^.{8,30}$/,
        "密码长度8-30字符"
      )
    ],
    checkPwd: [
      ruleNormal("请再次输入密码"),
      { validator: this.validatePass2, trigger: 'blur' }
    ],
  }

  private submitForm(formName){
    (this.$refs[formName] as HTMLFormElement).validate(async (valid) =>{
      if(valid){
        let params = {
        teacherId:this.chooseIdArray[0],
        newPassword:this.old2NewPwd['newPwd']
      }
      try {
        let res = await resetPasswords(params)
        this.$message.warning("重置成功")
        this.showReset = false;
      } catch (error) {
        this.$message.error(error||"重置失败！")
        this.showReset = false;
      }
      }
    })
  }

  // 重置密码
  private async resetPwd(){
    if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请勾选！");
      return false;
    }
    if (this.chooseIdArray.length >= 2) {
      this.$message.warning("一次只能重置一条！");
      return false;
    }
      this.showReset = true;
  }

  //获取教师总人数/有效人数
  private async getValidTeacherNum() {
    try {
      let res = await validTeacherNum();
      this.validTeacherData = res.data;
    } catch (error) {
      this.$message.error(error||"获取数据失败！")
    }

  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //获取页面参数
  private async getParams() {
    try {
      let res = await getTeacherMaintainParam();
      this.projects = res.data.projects;
      this.sources = res.data.sources;
      this.schools = res.data.schools;
      this.genders = res.data.genders;
      this.subjects = res.data.subjects;
      this.professionals = res.data.professionals;
      this.grades = res.data.grades;
      this.districts = res.data.districts;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // "获取列表"接口和"获取短信教师名单"接口，传参
  private deliverParams () {
    return {
      current: this.pageNo, //当前页
      schoolName: this.schoolName, //单位名称
      size: this.pageSize, //记录数
      teacherIsBlacklist: this.isBlacklist, //是否黑名单 0:否 ; 1:是
      teacherName: this.teacherName, //教师名称
      teacherValid: this.isValid, // 是否有效 0:是 ; 1:否
      isActivate: this.isActivate, //是否计划 0:否 ; 1:是
      subjectId:this.subjectId,
      districtId:this.districtId
    }
  }

  //上传地址
  get maintainUploadUrl() {
    return window.config.baseUrl4Shool + "/baseinfo/maintain/upload";
  }

  //上传前校验（不校验 projectId）
  private beforeMaintainUploadHandle(file) {
    const suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
    if (suffix !== "xlsx") {
      this.$message.error("请上传 xlsx 格式的文件");
      return false;
    }
    window['$showLoading']('#app');
    const date = +new Date();
    this.maintainUploadData = { progressId: date };
    (this as any).progressData = {
      uuid: date,
      fileName: file.name,
      progressVisible: true,
      uploadStatus: 'uploading',
    };
    return true;
  }

  //上传成功回调
  private maintainUploadSuccess(res) {
    this.importDialogVisible = false;
    (this as any).handleUploadSuccess(res, '教师名单维护导入失败.xlsx');
  }

  //提交上传
  private submitMaintainUpload() {
    (this.$refs['upload'] as any).submit();
    this.importDialogVisible = false;
  }

  //导出
  private exportHandle() {
    (this as any).downloadHandle("exportTeacherMaintain", "教师名单维护.xlsx", this.deliverParams());
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let res = await getTeacherMaintain(this.deliverParams());
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  // 重置搜索条件
  private resetSearch() {
    this.schoolName = "";
    this.isValid = null;
    this.isBlacklist = null;
    this.isActivate = null;
    this.subjectId = "";
    this.districtId = "";
    this.teacherName = "";
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v) {
    this.chooseIdArray = v.map(item => {
      return item.teacherId;
    });
    // 勾选的单行的内容 -- 用于删除操作等
    this.chooseRowArray = [...v];
  }

  //点击查看
  private showDetailHandle(projectId, otherinfoSourceId, teacherId) {
    this.projectId = projectId; // 项目id
    this.sourceId = otherinfoSourceId; // 来源id
    this.currentTeacherId = teacherId;
    this.showDetail = true;
  }

  //点击”添加”或”编辑”弹窗处理
  private async showEditDialog(type, row) {
    // 确保 schools 数据已加载（编辑时需要用于县区联动）
    if (this.schools.length === 0) {
      await this.getParams();
    }
    //记录是”添加”还是”修改”
    this.editType = type;
    //获取弹窗数据对象
    if (row) {
      this.editFormData = {
        // otherinfoIsRecommend: row.otherinfoIsRecommend, //是否推荐 0:推荐, 1:不推荐
        // otherinfoProjectId: row.projectId, //项目id
        // otherinfoSourceId: row.otherinfoSourceId, //来源id
        // otherinfoSubject: row.subjectId, //科目
        teacherAge: row.teacherAge, //年龄
        teacherBirthday: row.teacherBirthday, //出生年日
        teacherCard: row.teacherCard, //身份证号
        teacherGenderId: row.teacherGenderId, //性别id
        teacherGradeId: row.teacherGradeId, //任课年级
        teacherId: row.teacherId, //教师信息id
        teacherName: row.teacherName, //教师姓名
        teacherPhone: row.teacherPhone, //手机号
        teacherProfessionalId: row.teacherProfessionalId, //职称
        teacherDistrictId: row.teacherDistrictId, //所属市县id
        teacherSchoolId: row.teacherSchoolId, //所属学校id
        teacherTeachingAge: row.teacherTeachingAge, //教龄
        teacherIsBlacklist: row.teacherIsBlacklist,
        // otherinfoIsRecommendValue: row.otherinfoIsRecommendValue //是否推荐
      };
    } else {
      this.editFormData = {};
    }
    //显示弹窗
    this.dialogFormVisible = true;
  }

  //删除处理
  private deleteHandle() {
    //操作前的校验
    // if (!this.operationCheck()) return false;
    // 需求更改后的逻辑
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return false;
    }
    //询问是否删除
    this.$confirm("确定删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      // let params = {
      // ids: this.chooseIdArray,
      // projectId: this.projectId,
      // sourceId: this.sourceId
      // };
      // 流程改之后
      let tempArr: Array<object> = [];
      this.chooseRowArray.forEach(v => {
        tempArr.push({
          sourceId: v[`sourceId`],
          teacherId: v[`teacherId`], //教师id
          projectId: v[`projectId`] //项目id
        });
      });
      try {
        // await deleteTeacherInfo(tempArr);
        this.$message.success("删除成功");
        //操作成功，重新获取列表
        this.getData();
      } catch (error) {
        // this.$message.error(error || "删除失败");
        this[`$message`]({
          type: "error",
          message: error!.mesg ? error!.mesg : error
        });
      }
    });
  }

  //点击“加入黑名单”
  private showAddBlackListDialog() {
    // if (this.chooseIdArray.length <= 0) {
    //   this.$message.warning("请先勾选！");
    //   return;
    // }
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return;
    }
    // if (this.chooseRowArray.length >= 2) {
    //   this.$message.warning("一次只能修改一条！");
    //   return;
    // }

      if(this.chooseRowArray.length === 1){ // 只修改1条则显示reason
      this.tableData.forEach(element => {
        if(element['teacherId'] === this.chooseRowArray[0]['teacherId']){
          this.$set(this.blackListEditForm,'reason',element['teacherBlacklistReason'])
        }
      });
      }else{
        this.$set(this.blackListEditForm,'reason','')
      }
      this.blackListFormVisible = true;
  }

  //加入黑名单的“保存”处理
  private async saveEditHandle() {
    // 流程改之前
    // let params = {
    //   blacklistReason: this.editForm.reason, //加入黑名单的原因
    //   ids: this.chooseIdArray, //教师id
    //   projectId: this.projectId //项目id
    // };
    // 流程改之后
    let tempArr: Array<object> = [];
    this.chooseRowArray.forEach(v => {
      tempArr.push({
        blacklistReason: this.blackListEditForm[`reason`], //加入黑名单的原因
        teacherId: v[`teacherId`] //教师id
        // projectId: v[`projectId`] //项目id -- 暂时不需要
      });
    });
    try {
      this.fullscreenLoading = true;
      await addBlackList(tempArr);
      this.fullscreenLoading = false;
      this.blackListEditForm[`reason`] = "" // 清空黑名单原因
      this.$message.success("加入成功");
      this.blackListFormVisible = false;
      this.getData();
    } catch (error) {
      this.fullscreenLoading = false;
      // this.$message.error(error || "加入失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //移出黑名单
  private async removeBlackListHandle() {
    // if (this.chooseIdArray.length <= 0) {
    //   this.$message.warning("请先勾选！");
    //   return;
    // }
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return;
    }
    // let params = {
    //   ids: this.chooseIdArray, //教师id
    //   projectId: this.projectId //项目id
    // };
    // 流程改之后
    let tempArr: Array<object> = [];
    this.chooseRowArray.forEach(v => {
      tempArr.push({
        teacherId: v[`teacherId`] //教师id
        // projectId: v[`projectId`] //项目id
      });
    });
    try {
      this.fullscreenLoading = true;
      await removeBlackList(tempArr);
      this.fullscreenLoading = false;
      this.$message.success("移出成功");
      this.getData();
    } catch (error) {
      this.fullscreenLoading = false;
      // this.$message.error(error || "移出失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //点击“确认无效
  private showNoValidDialog() {
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return;
    }

    this.tableData.forEach(element => {
        this.$set(this.validationEditForm, 'reason', element['teacherValidReason'])
    });

    this.validationFormVisible = true;
  }

  //确认有效无效
  private async validHandle(v) {
    //操作前的校验
    // if (!this.operationCheck()) return false;
    if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请勾选！");
      return false;
    }
    try {
      // 改流程前
      // let params = {
      //   ids: this.chooseIdArray, //教师信息id
      //   otherinfoValid: v, //是否有效 0:有效 ; 1:无效
      //   projectId: this.projectId, //项目id
      //   sourceId: this.sourceId //来源id
      // }
      // 改流程后
      let params = {
        ids: this.chooseIdArray,
        teacherValid: v, // 是否有效 0 有效 1 无效
        teacherValidReason: this.validationEditForm[`reason`]
      };
      this.fullscreenLoading = true;
      await markValid(params);
      this.fullscreenLoading = false;
      this.$message.success("标记成功");
      this.getData();
    } catch (error) {
      this.fullscreenLoading = false;
      // this.$message.error(error || "标记失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }


  //激活账号
  private async activateAccount() {
    //操作前的校验
    // if (!this.operationCheck()) return false;
    if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请勾选！");
      return false;
    }
    try {
      this.fullscreenLoading = true;
      await activateAccount(this.chooseIdArray);
      this.fullscreenLoading = false;
      this.$message.success("激活成功");
      this.getData();
    } catch (error) {
      this.fullscreenLoading = false;
      // this.$message.error(error || "标记失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }









  //推荐和取消推荐
  private async recommendHandle(v) {
    //操作前的校验
    if (!this.operationCheck()) return false;
    try {
      let params = {
        ids: this.chooseIdArray, //教师信息id
        otherinfoIsRecommend: v, //是否推荐 0:是, 1:否
        projectId: this.projectId, //项目id
        sourceId: this.sourceId //来源id
      };
      //   await setRecommend(params);
      this.$message.success("设置成功");
      this.getData();
    } catch (error) {
      // this.$message.error(error || "标记失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //删除、确认有效无效、推荐、取消推荐，操作前的校验
  private operationCheck() {
    if (!this.projectId) {
      this.$message.warning("请选择项目！");
      return false;
    } else if (!this.sourceId) {
      this.$message.warning("请选择来源！");
      return false;
    } else if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请勾选！");
      return false;
    } else {
      return true;
    }
  }

  //点击”发送通知”、”发送短信息”处理
  private async showSendMessageHandle(v) {
    // 不再在这里调用 getMsgTeacher，交给子组件处理
    this.showSendMessage = true;
    this.msgType = v;
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
